import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventTypes } from 'src/app/core/models/events.model';
import { EventService } from 'src/app/core/services/event.service';

@Component({
  selector: 'app-big-red-button-modal',
  templateUrl: './big-red-button-modal.component.html',
  styleUrls: ['./big-red-button-modal.component.scss']
})
export class BigRedButtonModalComponent implements OnInit{

  public loading: boolean = false;
  public signSubmitted: boolean = false;

  @Input() claimId?: string;
  @Output ('agreeEventEmitter') agreeEventEmitter = new EventEmitter();

  constructor(
    @Optional() public dialog: MatDialogRef<BigRedButtonModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { claimId?: string },
    private eventService: EventService
  ){
  }

  async ngOnInit(){
    if (this.dialog) {
      this.dialog.disableClose = true;
    }
    
    // Envia evento de carregamento da página de confirmação
    const claimId = this.claimId || this.data?.claimId;
    await this.eventService.sendEventWithCaseId(
      EventTypes.BRB_LOAD_PAGE,
      claimId
    );
  }

  get isSubmitted(): boolean {
    return this.signSubmitted;
  }

  public showSignatureMessage(): void {
    this.loading = true;

    setTimeout(() => {
      this.loading = false;
      this.signSubmitted = true;
      this.agreeEventEmitter.emit(true);
    }, 1000);
  }

  public confirmAgreementsBRB(): void {
    this.showSignatureMessage();
  }

}
